module.exports = __webpack_public_path__ + "static/media/ic_editAvatar.33ea15be.svg";